<div class="plans-container">
  <div class="nav-bar">
    <div class="nav-bar-title">برنامه</div>
  </div>
  <div class="plans-holder">
    <div class="plans-tabs">
      <div class="plans-tab" (click)="changeTab(0)">
        <div
          class="plans-tab-title"
          [ngClass]="selectedTab === 0 ? 'blue' : 'black'"
        >
          برنامه‌های غذایی
        </div>
      </div>
      <div class="plans-tab" (click)="changeTab(1)">
        <div
          class="plans-tab-title"
          [ngClass]="selectedTab === 1 ? 'blue' : 'black'"
        >
          برنامه من
        </div>
      </div>
      <div class="plans-tabs-indicator" id="tabs-indicator"></div>
    </div>
    <div class="plans-tab-container" style="right: -100%" id="plans-tab0">
      <div *ngIf="dataIsReady">
        <div class="plans-personal-diet" (click)="personalSelected()">
          <img src="{{ personalDiet?.image }}" />
          <div class="plans-personal-title">برنامه غذایی خودت رو بساز</div>
          <div class="plans-personal-bottom-box">
            <img src="assets/plans/plus-white.svg" />
            <div class="plans-personal-bottom-box-title">ساختن برنامه شخصی</div>
            <div class="plans-personal-bottom-box-duration">۳۰ روز</div>
          </div>
        </div>
        <div
          *ngFor="let category of dietsListCategories; let last = last"
          [ngStyle]="{ 'padding-bottom': last ? '24px' : '0' }"
        >
          <div class="plans-category-title">{{ category.name }}</div>
          <div class="plans-diet-type-list">
            <div
              *ngFor="let dietType of category.dietTypes; let last = last"
              class="plans-diet-type"
              [ngStyle]="{ 'margin-left': last ? '16px' : '0' }"
              (click)="dietTypeSelected(dietType)"
            >
              <img src="{{ dietType?.image }}" />
              <div class="plans-diet-type-holder">
                <div class="plans-diet-type-name">{{ dietType.name }}</div>
                <div class="plans-diet-type-duration">
                  {{ dietType.days }} روز
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="plans-tab-container" id="plans-tab1">
      <app-plan-overview style="position: relative"></app-plan-overview>
    </div>
  </div>
</div>
